export class CMProfileSocial {

    public name: string;
    public link: string;

    public _type: string;

    public constructor() {
        this._type = '';
        this.name = '';
        this.link = '';
    }

    public fromRaw(data) {
        this._type = data._type;
        this.name = data.name;
        this.link = data.link;
        return this;
    }

    get type() {
        return this._type;
    }

}
